module.exports = __webpack_public_path__ + "static/sql-927f10effc5a31e604435452d0b05035.png";